import React from 'react';
import { useAudio } from '../hooks';
import { PredictionSegment } from '../types';

interface AudioPlayerProps {
  file: File | null;
  predictionList: PredictionSegment[] | null;
  showScores: boolean;
}

export const AudioPlayer: React.FC<AudioPlayerProps> = ({ file, predictionList, showScores }) => {
  const {
    waveformRef,
    waveSurferRef,
    isPlaying,
    togglePlayPause,
    currentTime,
    duration,
  } = useAudio({ file, predictionList, showScores });

  // Formater le temps (secondes → MM:SS)
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  if (!file) {
    return null;
  }

  return (
    <div>
      {waveSurferRef.current && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <button
            className="button"
            onClick={togglePlayPause}
            disabled={!waveSurferRef.current || !waveSurferRef.current.isReady}
          >
            {isPlaying ? '⏸ Pause' : '▶ Play'}
          </button>
          <span style={{ fontSize: '14px', color: 'rgb(72, 78, 82)' }}>
            {waveSurferRef.current ? `${formatTime(currentTime)} / ${formatTime(duration)}` : '0.0s / 0.0s'}
          </span>
        </div>
      )}
      
      {/* Conteneur de la waveform */}
      <div className="waveform-container" ref={waveformRef}></div>
      
      {/* Légende des scores (si les scores sont affichés) */}
      {showScores && predictionList && predictionList.length > 0 && (
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          <p>🟢 Vert : Score &lt; 15 (Bonne qualité)</p>
          <p>🟠 Orange : 15 ≤ Score ≤ 30 (Qualité moyenne)</p>
          <p>🔴 Rouge : Score &gt; 30 (Mauvaise qualité)</p>
        </div>
      )}
    </div>
  );
};
